import { IFeatures } from '@GFTypes/GameStoreTypes/Features';

export const FEATURES_DEFAULT: IFeatures = {};
